/*!
 * KoliBri - The accessible HTML-Standard
 */
import { g as getI18nInstance, i as initializeI18n } from './i18n-C73LqPIs.js';
import { F as isTestMode } from './common-D-vggmh2.js';

let translate = (key, options) => {
    var _a;
    const i18n = (_a = getI18nInstance()) !== null && _a !== void 0 ? _a : initializeI18n('de');
    return i18n.translate(key, options);
};
if (isTestMode()) {
    translate = (key) => key;
}

export { translate as t };
//# sourceMappingURL=i18n-CvFPh0g5.js.map

//# sourceMappingURL=i18n-CvFPh0g5.js.map